// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { ExternalLink } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconExternalLink(props: any) {
    return <IconBase icon={ExternalLink} {...props} />
  }

  export default IconExternalLink
  